var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"align":"center"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-card',{staticClass:"d-flex justify-center align-center",attrs:{"rounded":"lg","min-height":"268"}},[_c('h3',[_vm._v(_vm._s(_vm.error))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }